import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const ApiTags = Object.freeze({
  Accounts: 'Accounts',
  Applicants: 'Applicants',
  Assessments: 'Assessments',
  GeneratedAssessments: 'GeneratedAssessments',
  AssessmentTypes: 'AssessmentTypes',
  ApplicantComments: 'ApplicantComments',
  Cycles: 'Cycles',
  Files: 'Files',
  HiringAssessmentTypes: 'HiringAssessmentTypes',
  Phases: 'Phases',
  PublishedAssessments: 'PublishedAssessments',
  PublishedJobPostings: 'PublishedJobPostings',
  LandingPages: 'LandingPages',
  SkillbuilderAssessmentTypes: 'SkillbuilderAssessmentTypes',
  Batteries: 'Batteries',
  BatterySubmissions: 'BatterySubmissions',
  Integrations: 'Integrations',
  Organizations: 'Organizations',
  OrganizationGroups: 'OrganizationGroups',
  Locations: 'Locations',
  Users: 'Users',
  HiringAnalytics: 'HiringAnalytics',
  EmailTemplates: 'EmailTemplates',
  TextTemplates: 'TextTemplates',
  SkillbuilderCycles: 'SkillbuilderCycles',
  SkillbuilderManagers: 'SkillbuilderManagers',
  HelpLinks: 'HelpLinks',
  HiringTemplates: 'HiringTemplates',
  HiringViews: 'HiringViews',
  HiringViewsDetails: 'HiringViewsDetails',
  HiringViewsCycles: 'HiringViewsCycles',
  CyclesBoostInvitableApplicants: 'CyclesBoostInvitableApplicants',
  CycleBoostInvitableApplicant: 'CycleBoostInvitableApplicant',
  SBTrainingUsers: 'SBTrainingUsers',
  Triggers: 'Triggers',
  ModuleInfos: 'ModuleInfos',
  Statuses: 'Statuses',
  Regions: 'Regions',
  Degrees: 'Degrees',
  SBCandidates: 'SBCandidates',
  Jobs: 'Jobs',
  JobCategories: 'JobCategories',
  jobPostings: 'JobPostings',
  JobTypes: 'JobTypes',
  ExpertiseCategory: 'ExpertiseCategory',
  CycleOpenInvites: 'CycleOpenInvites',
  AssessmentInvites: 'AssessmentInvites',
  CyclesPhases: 'CyclesPhases',
  CyclesStages: 'CyclesStages',
  CycleStageConfigs: 'CyclesStageConfigs',
  CyclePasses: 'CyclePasses',
  StageProgresses: 'StageProgresses',
  EmailHistory: 'EmailHistory',
  InviteConfigTemplate: 'InviteConfigTemplate',
  FindCandidates: 'FindCandidates',
  FindCandidatesInvitations: 'FindCandidatesInvitations',
  FindCandidatesRecipients: 'FindCandidatesRecipients',
  FindCandidatesQueryAnalytics: 'FindCandidatesAnalytics',
  FindCandidatesQuerySourceAnalytics: 'FindCandidatesAnalytics'
})

export const ApiAbstractIds = Object.freeze({
  List: 'LIST',
  PartialList: 'PARTIAL-LIST',
  Export: 'EXPORT'
})

export const ApiMethods = Object.freeze({
  Get: 'GET',
  Post: 'POST',
  Delete: 'DELETE',
  Patch: 'PATCH',
  Put: 'PUT'
})

export const ApiResponseTypes = Object.freeze({
  ArrayBuffer: 'arraybuffer'
})

export const apiSlice = createApi({
  reducerPath: 'apiReducer',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/' }),
  tagTypes: Object.keys(ApiTags),
  endpoints: () => ({})
})

export function providesList (result, tag) {
  return result?.items
    ? [
        ...result.items.map(({ id }) => ({ type: tag, id: id })),
        { type: tag, id: ApiAbstractIds.List }
      ]
    : [{ type: tag, id: ApiAbstractIds.List }]
}

/**
 * Extracts the ID from the header X-RESOURCE-ID and returns it with the response data.
 * @param response
 * @param meta
 * @returns {Promise<{data: object, id: int|string}>}
 */
export async function extractHeaderIdAndData (response, meta) {
  const id = meta.response.headers.get('x-resource-id')

  const data = await response

  return { data, id }
}
